import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { SET_ACCOUNT } from 'store/account/action'
import { toast } from "react-toastify"

import { GET, POST } from 'helpers/api'
import { clearTemporaryStorage } from 'helpers/helpers'

import loginIcon from 'assets/icons/login.svg'

function Login() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const [user, setUser] = useState({ "login": "", "password": "" })

	async function handleSubmit(e) {
		e.preventDefault();

		var sendData = {
			user_name: user.login.toLowerCase(),
			password: user.password
		}
		clearTemporaryStorage()
		var response = await POST('/users/login/', sendData, { loader: true, notification: false })
		if (response?.status >= 200) {
			response = response.data;

			localStorage.setItem("login", user.login.toLowerCase());
			localStorage.setItem("role", response.role);
			localStorage.setItem('token', response.access)
			localStorage.setItem('refresh', response.refresh)

			var account = await GET('/users/me/', {}, { loader: true, notification: false })
			dispatch(SET_ACCOUNT({ ...account.data, ...response }))

			switch (response.role) {
				case 'MANAGEMENT':
					navigate("/managment/users")
					break;
				case 'WAREHOUSE_RAW':
					navigate("/warehouse-raw/dashboard")
					break;
				case 'WAREHOUSE_FINISHED':
					navigate("/warehouse-finished/dashboard")
					break;
				case 'PRODUCTION':
					navigate("/production/dashboard")
					break;
				case 'TECHNOLOGIST':
					navigate("/technologist/dashboard")
					break;
				case 'SALES':
					navigate("/sales/dashboard")
					break;
				case 'PROCUREMENT':
					navigate("/procurement/dashboard")
					break;
				default:
					toast.error(t('you_do_not_have_access'))
					break;
			}
		}
	}

	return (
		<>
			<div className="login">
				<div>
					<div className="login-title">
						NEHIR
					</div>
					<div className="login-subtitle">{t('login_to_system')}</div>
				</div>

				<div className="login-card">
					<form autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
						<div className="form-group w-100">
							<label htmlFor="login">{t('login_or_email')}</label>
							<div className="position-relative">
								<input
									id="login"
									className="form-control"
									name="login"
									placeholder={t('enter_login_or_email')}
									required
									autoFocus={true}
									value={user.login}
									onChange={(e) => setUser({ ...user, 'login': e.target.value.toLowerCase() })} />
							</div>
						</div>

						<div className="form-group w-100">
							<label htmlFor="password">{t('password')}</label>
							<div className="position-relative">
								<input
									id="password"
									className="form-control"
									name="password"
									type="password"
									placeholder={t('enter_password')}
									required
									value={user.password}
									onChange={(e) => setUser({ ...user, 'password': e.target.value })} />
							</div>
						</div>

						<button type="submit" className={`login-btn ${(!user.login || !user.password) ? 'disabled' : ''}`}>
							<img src={loginIcon} alt="login" />
							{t('sign_in')}
						</button>
					</form>
				</div>
			</div>
		</>
	)
}

export default Login;